"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var Tag = function (props) {
    var name = props.name;
    return (react_1.default.createElement("div", { className: "badge badge-light border" },
        react_1.default.createElement("span", { className: "text-info" }, name)));
};
Tag.propTypes = {
    name: prop_types_1.default.string,
};
exports.default = Tag;
//# sourceMappingURL=Tag.js.map